// extracted by mini-css-extract-plugin
module.exports = {"loadingOverlay":"commonStyles_loadingOverlay__2DhDX"};